import { render, staticRenderFns } from "./BaseFieldText.vue?vue&type=template&id=6d53613c&scoped=true"
import script from "./BaseFieldText.vue?vue&type=script&lang=js"
export * from "./BaseFieldText.vue?vue&type=script&lang=js"
import style0 from "./BaseFieldText.vue?vue&type=style&index=0&id=6d53613c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d53613c",
  null
  
)

export default component.exports